import _ from 'lodash';

/**
 * Pick a random portfolio from the list
 * @param portfolios {Array<Object>}
 * @returns {*}
 */
const pickRandom = (portfolios) => _.sample(portfolios);


/**
 * Filter portfolios based on the criteria and pick a random one
 * @param portfolios {Array<Object>}
 * @param criteria {Object} - Criteria to filter the portfolios by  (e.g. { asset_class: 'fixed' })
 * @returns {*}
 */
const filterAndPick = (portfolios, criteria) => {
  const filteredPortfolios = portfolios.filter(portfolio => _.isMatch(_.get(portfolio, 'user_tags', {}), criteria));
  return pickRandom(filteredPortfolios);
};



/**
 * Decide on a fixed income portfolio based on user preferences and equity allocation
 * @param portfolios {Array<Object>}
 * @param equityAllocation {number} - The equity allocation percentage
 * @returns {null|*}
 */
const decideFixedIncome = (portfolios, equityAllocation) => {
  if (equityAllocation < 99) {
    return filterAndPick(portfolios, { asset_class: 'fixed' });
  }
  return null;
};

/**
 * Decide on equity portfolios based on user preferences and equity allocation
 * @param portfolios {Array<Object>}
 * @param userResponses {Object}
 * @param equityAllocation {number} - The equity allocation percentage
 * @returns {*[]}
 */
const decideEquityPortfolio = (portfolios, userResponses, equityAllocation) => {
  let selectedEquityPortfolios = [];
  if (equityAllocation >= 50 && userResponses.dividend===true) {
    // Explicitly find and include one dividend stock portfolio
    const dividendStockPortfolios = portfolios.filter(p =>
      _.get(p, 'user_tags.asset_type') === 'stock' &&
      _.get(p, 'user_tags.objective') === 'dividend');
    if (dividendStockPortfolios.length > 0) {
      selectedEquityPortfolios.push(_.sample(dividendStockPortfolios));
    }

    // If singleStock is true, also include one non-dividend stock portfolio
    if (userResponses.singleStock) {
      const otherStockPortfolios = portfolios.filter(p =>
        _.get(p, 'user_tags.asset_type') === 'stock' &&
        _.get(p, 'user_tags.objective') !== 'dividend');
      if (otherStockPortfolios.length > 0) {
        // Ensure the selected portfolio is not the same as the dividend stock portfolio
        const nonDividendStock = _.sample(otherStockPortfolios.filter(p => !selectedEquityPortfolios.includes(p)));
        if (nonDividendStock) {
          selectedEquityPortfolios.push(nonDividendStock);
        }
      }
    }
  }

  return selectedEquityPortfolios;
};


const maybeIncludeInternational = (portfolios, userResponses, selectedPortfolios) => {
  if (userResponses.international) {
    const internationalPortfolio = filterAndPick(portfolios, { 'user_tags.region': ['global', 'ex_us'] });
    // Ensure the international portfolio is included if found
    if (internationalPortfolio) {
      selectedPortfolios.push(internationalPortfolio);
    }
  }
  return selectedPortfolios;
};



const filterDomesticEquityEtfs = (portfolios)=>{
  return portfolios.filter(p => _.get(p, 'user_tags.asset_type') === 'etf' && _.get(p, 'user_tags.region') === 'domestic')
}


const checkForTilt = (portfolios, userResponses)=>{
  if (!['growth_tilt', 'value_tilt'].includes(userResponses.tilt)) {
    return;
  }
  let selected = null;
  portfolios.forEach(p => {
    console.log(p?.user_tags, userResponses.tilt)
    if (p?.user_tags?.objective === userResponses.tilt) {
      selected = p;
    }

  });
  return selected
}


/**
 * Apply the rules to select portfolios based on user responses
 * @param portfolios {Array<Object>} - List of portfolios to select from
 * @param userResponses {Object} - User responses to the form
 * @returns {*}
 */
const applyRules = (portfolios, userResponses) => {
  const { equity } = userResponses;
  // Make decisions based on fixed income and equity allocations
  const fixedIncomePortfolio = decideFixedIncome(portfolios, equity);
  let equityPortfolios = decideEquityPortfolio(portfolios, userResponses, equity);

  // Start assembling the selected portfolios
  let selectedPortfolios = [];
  if (fixedIncomePortfolio) selectedPortfolios.push(fixedIncomePortfolio);
  if (equityPortfolios) selectedPortfolios = selectedPortfolios.concat(equityPortfolios);

  selectedPortfolios = maybeIncludeInternational(portfolios, userResponses, selectedPortfolios);
  const domesticETFPortfolios = filterDomesticEquityEtfs(portfolios);
  // Condition to include an ETF portfolio tagged with asset_type='etf' and region='domestic'
  if (!userResponses.singleStock && !userResponses.dividend && !userResponses.international && equity > 0) {
    if (domesticETFPortfolios.length > 0) {
      // Include one domestic ETF portfolio
      selectedPortfolios.push(_.sample(domesticETFPortfolios));
    }
  }
  else if (userResponses.equity > 50 && userResponses.singleStock===false || userResponses.dividend===false) {
    selectedPortfolios.push(_.sample(domesticETFPortfolios));
  }
  let maybeTilt = checkForTilt(portfolios, userResponses);
  console.log(maybeTilt);
  if (maybeTilt){
    selectedPortfolios.push(maybeTilt);
  }
  return _.uniqBy(selectedPortfolios, 'id'); // Ensure unique portfolios by ID to avoid duplicates
};


export { applyRules }